import {useCallback, useEffect} from 'react';

import {hotkeyPressed} from '../../../util/hotkeys';
import {useUndoRedo} from '../hooks/useUndoRedo';

export const useUndoRedoKeyboardShortcuts = () => {
  const {undo, redo} = useUndoRedo();

  const handleWorkspaceUndo = useCallback(
    (e: KeyboardEvent) => {
      if (hotkeyPressed(e, 'undoWorkspaceAction')) {
        undo?.(true);
      }
    },
    [undo]
  );

  const handleWorkspaceRedo = useCallback(
    (e: KeyboardEvent) => {
      if (hotkeyPressed(e, 'redoWorkspaceAction')) {
        redo?.(true);
      }
    },
    [redo]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleWorkspaceUndo);
    document.addEventListener('keydown', handleWorkspaceRedo);
    return () => {
      document.removeEventListener('keydown', handleWorkspaceUndo);
      document.removeEventListener('keydown', handleWorkspaceRedo);
    };
  }, [handleWorkspaceUndo, handleWorkspaceRedo]);
};
